
import { defineComponent, computed } from 'vue'
import recherchevehicule from "@/services/recherche_page.services";
import * as config from "@/config.json";

export default defineComponent({
  name: 'cardItem',
  props: {
    locale:String,
    defaultImg:String,
    category: String,
    id:String,
    price: Number,
    discount: Number,
    brand: String,
    model: String,
    sousModel: String,
    year: Number,
    type: Number,
    route: String,
    stringify: String,
    odo: Number,
    fuel: String,
    traction: String,
    image: String,
    instavid: String,
    carfax: String,
    financement: Array 
  },
  data () {
    return {
      imageLink: this.$props.image,
      carfaxLink: this.$props.carfax
    }
  },
  setup (props: any) {
    const {
      state,
      switchCards
    } = recherchevehicule;
    const altTag = props.year + " " + props.brand + " " + props.model;
    const url = window.location.protocol + "//" + window.location.hostname;

    console.log(props.instavid);


    // eslint-disable-next-line no-undef
    let energyTypes = [ state.jsonFile['vehicule']['energyType']["electric"], state.jsonFile['vehicule']['energyType']['hybrid']]
    let bg_green_class = computed(() => energyTypes.includes(props.fuel.toLowerCase()) ? "cards-inventaire__ess-green" : "");

    // Instavid360
    let instavidBackgoundImg = "//" + config.photoVehiculePath + "/1024/" + config.instavidBackgroundImg;
    let instavidLogoImg = config.instavidLogoImg;

    return {
      state,
      switchCards,
      url,
      altTag,
      bg_green_class,
      instavidBackgoundImg,
      instavidLogoImg
    }
  }
})
